import usePageTitle from "../hooks/usePageTitle";

function PrivacyPolicy() {
  usePageTitle(`Privacy Policy | Fudopia | Meet. Eat. Repeat.`);
  return (
    <section>
      <h1>Privacy Policy</h1>
      <div>
        <p>Last updated: 30th of April, 2025</p>
      </div>
      <div className="section faqs">
        <div>
          <h3>1. What information do we collect?</h3>
          <p>
            When you sign up for Fudopia, we collect your name, username, and
            email address. You can also choose to add a short bio and your
            favorite food. We also track basic activity like which events you
            join or create and which dishes you favorite.
          </p>
          <p>
            We also collect device and browser info to help us improve how the
            site works.
          </p>
          <p>
            We <strong>don’t collect any payment information</strong> directly.
            All payments are handled securely through trusted services like
            Stripe.
          </p>
        </div>

        <div>
          <h3>2. What information is visible to others?</h3>
          <p>
            Other users can see your <strong>username</strong>,{" "}
            <strong>bio</strong>, and <strong>favorite food</strong>. That’s it!
            Your email address, real name, and any private info stay hidden.
          </p>
        </div>

        <div>
          <h3>3. How do we use your data?</h3>
          <p>We use your data to:</p>
          <ul>
            <li>Set up your account</li>
            <li>Suggest relevant dishes and events</li>
            <li>Support event coordination and communication</li>
            <li>Send you updates about your account and Fudopia features</li>
          </ul>
        </div>

        <div>
          <h3>4. Do we use cookies or analytics?</h3>
          <p>
            Yes, we use simple cookies and analytics tools to understand how
            people use Fudopia and to keep things running smoothly. You can
            manage cookies through your browser settings.
          </p>
        </div>

        <div>
          <h3>5. How is your data stored?</h3>
          <p>
            Your data is stored using secure, modern hosting services. We work
            with trusted third parties and do our best to keep everything safe.
          </p>
        </div>

        <div>
          <h3>6. Can I update or delete my data?</h3>
          <p>
            Absolutely. If you want to change or delete any personal data, just{" "}
            <a href="/contact" style={{ textDecoration: "underline" }}>
              reach out to us
            </a>
            . We’re happy to help.
          </p>
        </div>

        <div>
          <h3>7. Will this policy ever change?</h3>
          <p>
            We may update this Privacy Policy from time to time. If we make big
            changes, we’ll let you know through the platform.
          </p>
        </div>

        <div>
          <p>
            Got more questions?{" "}
            <a href="/contact" style={{ textDecoration: "underline" }}>
              Get in touch
            </a>
            — we’re here for you!
          </p>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
